import { Component, ElementRef, HostListener, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { MiscService } from 'app/shared/misc.service';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { filter, finalize } from 'rxjs/operators';

@Component({
  selector: 'app-seminav',
  templateUrl: './seminav.component.html',
  styleUrls: ['./seminav.component.scss']
})
export class SeminavComponent implements OnInit {
  title: string = '';
  description: string = '';
  breadcrumb: any[] = [];
  merchant: any;
  tooltipElement: HTMLElement | null = null;
  showTooltip = false;
  ussdSent = false;
  pendingApproval = false;
  countryCode: string;
  ussdCode: string = '';
  approved = false;
  rejected = false;
  isModalOpen: boolean = false;
  data: any = null; // Holds API response
  loading = false;
  ussdApplication$: Observable<any> | null = null;
  response: any; // Declare response to avoid TypeScript errors
  rejectionReason:string =''
  constructor(
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private router: Router,
    public miscService: MiscService,
    private el: ElementRef, private renderer: Renderer2
  ) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.title = this.route.snapshot.firstChild?.firstChild?.data?.title;
      this.description = this.route.snapshot.firstChild?.firstChild?.data?.desc;
      this.breadcrumb = this.route.snapshot.firstChild?.firstChild?.data?.breadcrumb;

      // Check if merchant is from Uganda and update Bulk Top up to Bulk Airtime
      const merchantDetails = this.miscService.getMerchantDetails();
      const isoCode = merchantDetails?.currency?.iso_code_2;

      if (isoCode === 'UG' && this.router.url.includes('/bulk-top-up')) {
        // Update title
        if (this.title && this.title.toLowerCase().includes('bulk top')) {
          this.title = this.title.replace(/Bulk Top up/gi, 'Bulk Airtime');
        }

        // Update description
        if (this.description && this.description.toLowerCase().includes('top up')) {
          this.description = this.description.replace(/top up/gi, 'airtime');
        }

        // Update breadcrumb
        if (this.breadcrumb && Array.isArray(this.breadcrumb)) {
          this.breadcrumb = this.breadcrumb.map(item =>
            typeof item === 'string' && item.toUpperCase().includes('BULK TOP UP')
              ? 'BULK AIRTIME'
              : item
          );
        }
      }

      if (this.router.url.includes('/pay-bills/')) {
        const segment = this.router.url.split('/pay-bills/')[1]?.split('/')[0]?.split('?')[0];
        const billNames: Record<string, string> = {
          electricity: 'Electricity',
          water: 'Water Bill',
          ura: 'Uganda Revenue Authority',
          nssf: 'National Social Security Fund',
        };
        const billName = billNames[segment];
        if (billName) {
          this.title = `Pay Bills (${billName})`;
        }
      }
    });

  }

  ngOnInit() {
    this.miscService.userSubject.subscribe(res => {
      if (res) {
        this.merchant = res;
      } else {
        this.merchant = this.miscService.getMerchantDetails();

      }

    });
    this.viewUSSDApplication();

    // Apply initial title and breadcrumb transformations for Uganda merchants
    const merchantDetails = this.miscService.getMerchantDetails();
    const isoCode = merchantDetails?.currency?.iso_code_2;

    if (isoCode === 'UG' && this.router.url.includes('/bulk-top-up')) {
      // Update title
      if (this.title && this.title.toLowerCase().includes('bulk top')) {
        this.title = this.title.replace(/Bulk Top up/gi, 'Bulk Airtime');
      }

      // Update description
      if (this.description && this.description.toLowerCase().includes('top up')) {
        this.description = this.description.replace(/top up/gi, 'airtime');
      }

      // Update breadcrumb
      if (this.breadcrumb && Array.isArray(this.breadcrumb)) {
        this.breadcrumb = this.breadcrumb.map(item =>
          typeof item === 'string' && item.toUpperCase().includes('BULK TOP UP')
            ? 'BULK AIRTIME'
            : item
        );
      }
    }

    if (this.router.url.includes('/pay-bills/')) {
      const segment = this.router.url.split('/pay-bills/')[1]?.split('/')[0]?.split('?')[0];
      const billNames: Record<string, string> = {
        electricity: 'Electricity',
        water: 'Water',
        ura: 'Uganda Revenue Authority',
        nssf: 'National Social Security Fund',
      };
      const billName = billNames[segment];
      if (billName) {
        this.title = `Pay Bills (${billName})`;
      }
    }

  }
  @HostListener('window:resize', [])
  onResize() {
    this.hide(); // Hide tooltip on window resize to reposition correctly
  }
  showUSSD = false; // Initially hidden

  toggleUSSD() {
    this.showUSSD = !this.showUSSD;
  }

  isUSSDCodeAvailable(): boolean {
    return !!this.merchant?.ussd_code && this.merchant.ussd_code !== null && this.merchant.ussd_code !== undefined;
  }
  
  getUSSDCountryCode(): string {
    if (this.response?.data?.ussd_code) {
      return this.response?.data?.countryCode || '';
    }
    return this.merchant?.country_code || ''; // Fetch country code from merchant if applicable
  }
  
  // getUSSDCode(): string {

  //   console.log('testing', this.response);
    
  //   if (this.response?.data?.ussd_code) {
  //     return this.response?.data?.ussd_code;
  //   }
  //   return this.merchant?.ussd_code || ''; // Use merchant USSD code if available
  // }
  // Function to check if USSD code is pending approval

  
  
  sendUSSD() {
    this.isModalOpen = true;
  
    setTimeout(() => {
      // Adjust `.bottom` position when modal opens
      const bottomElement = document.querySelector('.bottom') as HTMLElement;
      if (bottomElement) {
        this.renderer.setStyle(bottomElement, 'top', '250px'); // Push it down to avoid overlap
      }
  
      // Ensure modal is above everything
      const modal = this.el.nativeElement.querySelector('.modal-content');
      if (modal) {
        this.renderer.setStyle(modal, 'z-index', '1100');
      }
    }, 0);
  }
  
  closeModal() {
    this.isModalOpen = false;

    setTimeout(() => {
      const bottomElement = document.querySelector('.bottom') as HTMLElement;
      if (bottomElement) {
        this.renderer.setStyle(bottomElement, 'top', '150px'); // Reset position
        this.renderer.setStyle(bottomElement, 'display', 'block'); // Ensure it's visible
        this.renderer.setStyle(bottomElement, 'visibility', 'visible');
      }
    }, 100);
  }
  
  requestUSSDCode() {
    this.loading = true;

    this.sendUSSDRequest(this.merchant.merchant_id);
  }
  
  private sendUSSDRequest(merchantId: string) {
    this.miscService.applyForUSSD(merchantId)
      .pipe(finalize(() => this.loading = false))
      .subscribe({
        next: (response) => this.handleUSSDRequestSuccess(response),
        error: (error) => this.handleUSSDRequestError(error)
      });
  }
  
  private handleUSSDRequestSuccess(response: any) {
    console.log('Success:', response);
    this.viewUSSDApplication()
    this.showSuccessToast();
    this.closeModal();
  }
  
  private handleUSSDRequestError(error: any) {
    console.error('Error:', error);
  
    // Check if error response contains a message
    const errorMessage = error?.error?.message || 'Failed to send USSD request.';
    
    this.toastr.error(errorMessage, 'Error', {
      timeOut: 3000,
      progressBar: true,
      positionClass: 'toast-top-right'
    });
  }
  
  
  private showSuccessToast() {
    this.toastr.success('USSD request sent successfully!', 'Success', {
      timeOut: 3000,
      progressBar: true,
      positionClass: 'toast-top-right'
    });
  }
  

  viewUSSDApplication() {
    this.ussdApplication$ = this.miscService.getUSSDApplication(this.merchant.merchant_id);
    this.ussdApplication$.subscribe(
      (response) => {
        this.rejectionReason = response?.data?.rejection_reason;
      },
      (error) => {
        console.error('Error fetching USSD application:', error);
      }
    );
    
  
  }
  
  
  
  show(event: MouseEvent | TouchEvent) {
    this.hide(); 
    this.tooltipElement = this.renderer.createElement('div');
    
    this.tooltipElement.innerHTML = `
      <p style="font-weight: bold; color: #333;">Receive Money via USSD <br/> Code</p>
      <p style="font-size: 14px; font-weight: 400; color: #666; margin: 0;">
        Payments made easier with us.<br/> 
        Get a free USSD code for your <br/> business.
        Share your USSD code <br/>  with customers to make fast and convenient payments to you anyday, anytime.
      </p>
    `;
    
   
    this.renderer.setStyle(this.tooltipElement, 'position', 'absolute');
    this.renderer.setStyle(this.tooltipElement, 'background', 'white');
    this.renderer.setStyle(this.tooltipElement, 'padding', '14px');
    this.renderer.setStyle(this.tooltipElement, 'borderRadius', '5px');
    this.renderer.setStyle(this.tooltipElement, 'boxShadow', '0px 4px 6px rgba(0, 0, 0, 0.1)');
    this.renderer.setStyle(this.tooltipElement, 'zIndex', '9999');
 // Apply default styles

 let clientX = 0;
 let clientY = 0;

 if ('clientX' in event) {
   clientX = (event as MouseEvent).clientX;
   clientY = (event as MouseEvent).clientY;
 } else if ('touches' in event) {
   clientX = (event as TouchEvent).touches[0].clientX;
   clientY = (event as TouchEvent).touches[0].clientY;
 }

 // Check screen width for mobile vs. desktop positioning
 if (window.innerWidth <= 768) {
   // Center tooltip on mobile
   this.renderer.setStyle(this.tooltipElement, 'top', '40%'); // Adjusted to prevent it from being too low
   this.renderer.setStyle(this.tooltipElement, 'left', '50%');
   this.renderer.setStyle(this.tooltipElement, 'transform', 'translate(-50%, -50%)');
   this.renderer.setStyle(this.tooltipElement, 'max-width', '90%'); // Ensure it fits on small screens
 } else {
   // Position tooltip near the cursor for desktop
   this.renderer.setStyle(this.tooltipElement, 'top', `${Math.max(clientY, 50)}px`);
   this.renderer.setStyle(this.tooltipElement, 'left', `${clientX + 10}px`);
   this.renderer.setStyle(this.tooltipElement, 'max-width', '250px');
 }

 this.renderer.appendChild(document.body, this.tooltipElement);
  }


  showRejectionReason(event: MouseEvent | TouchEvent) {
    this.hide(); 
    this.tooltipElement = this.renderer.createElement('div');
  
    this.tooltipElement.innerHTML = `
      <p style="font-weight: bold; color: #333;">Rejection Reason</p>
      <p style="font-size: 14px; font-weight: 400; color: #666; margin: 0;">
       ${this.rejectionReason}
      </p>
    `;
    
   
    this.renderer.setStyle(this.tooltipElement, 'position', 'absolute');
    this.renderer.setStyle(this.tooltipElement, 'background', 'white');
    this.renderer.setStyle(this.tooltipElement, 'padding', '14px');
    this.renderer.setStyle(this.tooltipElement, 'borderRadius', '5px');
    this.renderer.setStyle(this.tooltipElement, 'boxShadow', '0px 4px 6px rgba(0, 0, 0, 0.1)');
    this.renderer.setStyle(this.tooltipElement, 'zIndex', '9999');
 // Apply default styles

 let clientX = 0;
 let clientY = 0;

 if ('clientX' in event) {
   clientX = (event as MouseEvent).clientX;
   clientY = (event as MouseEvent).clientY;
 } else if ('touches' in event) {
   clientX = (event as TouchEvent).touches[0].clientX;
   clientY = (event as TouchEvent).touches[0].clientY;
 }

 // Check screen width for mobile vs. desktop positioning
 if (window.innerWidth <= 768) {
   // Center tooltip on mobile
   this.renderer.setStyle(this.tooltipElement, 'top', '40%'); // Adjusted to prevent it from being too low
   this.renderer.setStyle(this.tooltipElement, 'left', '50%');
   this.renderer.setStyle(this.tooltipElement, 'transform', 'translate(-50%, -50%)');
   this.renderer.setStyle(this.tooltipElement, 'max-width', '90%'); // Ensure it fits on small screens
 } else {
   // Position tooltip near the cursor for desktop
   this.renderer.setStyle(this.tooltipElement, 'top', `${Math.max(clientY, 50)}px`);
   this.renderer.setStyle(this.tooltipElement, 'left', `${clientX + 10}px`);
   this.renderer.setStyle(this.tooltipElement, 'max-width', '250px');
 }

 this.renderer.appendChild(document.body, this.tooltipElement);
  }
  hide() {
    if (this.tooltipElement) {
      this.renderer.removeChild(document.body, this.tooltipElement);
      this.tooltipElement = null;
    }
  }
}
